
import SlWholeSaleDiscount from '../../../models/Sale/SlWholesaleDiscount'
export default async id => {
    try {
        let wholeSaleDiscount = await SlWholeSaleDiscount.where('wh_product_id',id).get()
        console.log(wholeSaleDiscount,'sdsds')
        return wholeSaleDiscount.data
    } catch (error) {
        return error.response.data
    }
}
